/**
 * @format
 * @flow
 */
import * as App from '../constants/reducers/App';

const initialState = {
  loading: false,
  modalOpen: false,
  modalTitle: '',
  modalText: '',
  errType: '',
  isErrBottomButton: false,
  errBottomButtonTarget: '',
  errBottomButtonText: '',
  errBottomButtonFunc: null,
  current_user: null,
  notification: []
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case App.MODAL_CHANGE:
      // console.log('modalchange', action)
      return {
        ...state,
        modalOpen: action.modalOpen,
        modalText: action.modalText,
        modalTitle: action.modalTitle
      };
    case App.ERROR_SHOW:
      // console.log('error_show', action)
      return { ...state, errMsg: action.errMsg, errorShow: action.errorShow };
    case App.ERROR_RESET:
      // console.log('error_show', action)
      return { ...state, errMsg: '', errorShow: false };
    case App.LOAD_START:
      // console.log('loasStartAction')
      return { ...state, loading: true };
    case App.LOAD_END:
      // console.log('loasEndAction')
      return { ...state, loading: false };
    case 'LOAD_SHOW':
      // console.log('loasEndAction')
      return { ...state, loading: true };
    case 'SET_NOTIFICATION_DATA':
      return { ...state, notification: action.data, loading: false };
    default:
      return state;
  }
}
